<template>
  <v-dialog
    v-model="diaryDialog"
    persistent
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card style="background-color: #f4f5fa;">
      <v-toolbar
        dark
        color="primary"
      >
        <v-btn
          icon
          dark
          @click="diaryDialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Diary Record</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn
            dark
            text
            @click="handleDiary"
          >
            Save
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <div>
        <center class="pt-2">
          {{ formatDate(bookingInfoProp.courseDate) }}
        </center>
        <v-tabs
          v-model="tabIndex"
          centered
          grow
          :show-arrows="false"
        >
          <v-tab @click="tab = 'summary'">
            Summary
          </v-tab>
          <v-tab @click="tab = 'exercies'">
            Exercies
          </v-tab>
          <v-tab @click="tab = 'aerobic'">
            Aerobic Activity
          </v-tab>
        </v-tabs>
        <section v-show="tab === 'summary'">
          <v-card>
            <v-card-title>
              Body Parts Exercised
            </v-card-title>
            <div class="pl-5 pr-5">
              <InputContainer
                ref="bodyPart"
                :configs="bodyPartConfig"
              >
              </InputContainer>
            </div>
          </v-card>

          <v-card class="mt-5">
            <v-card-title>
              Daily Evaluation
            </v-card-title>
            <div class="pl-5 pr-5 pb-10">
              <InputContainer
                ref="dailyEvaluation"
                :configs="dailyEvaluationConfig"
              >
              </InputContainer>
            </div>
          </v-card>
        </section>
        <ConfirmDialog
          v-model="confirmDeleteDialog"
          @confirm="confirmRemoveTrainingItem"
        >
          <div
            v-if="workingRemoveTrainingItem"
            class="text-h5 mt-5 mb-5"
          >
            <div>{{ getItemDesc(courseItems,workingRemoveTrainingItem.courseItemID) }}</div>
            <div>{{ getItemDesc(courseItemCategories,workingRemoveTrainingItem.courseItemCategoryID) }} <span v-if="workingRemoveTrainingItem.courseItemMachineID">({{ getItemDesc(courseItemMachines,workingRemoveTrainingItem.courseItemMachineID) }})</span></div>
          </div>
        </ConfirmDialog>
        <ConfirmDialog
          v-model="confirmDeleteTrainingAerobicItemDialog"
          @confirm="confirmRemoveTrainingAerobicItem"
        >
          <div
            v-if="workingRemoveTrainingAerobicItem"
            class="text-h5 mt-5 mb-5"
          >
            <div>
              <div>{{ getItemDesc(aerobicItems,workingRemoveTrainingAerobicItem.aerobicItemID) }}</div>
              <div>{{ workingRemoveTrainingAerobicItem.duration }} {{ workingRemoveTrainingAerobicItem.unit }}</div>
            </div>
          </div>
        </ConfirmDialog>
        <section
          v-show="tab == 'exercies'"
          class="pt-3"
        >
          <v-expansion-panels
            v-model="panel"
          >
            <v-expansion-panel
              v-for="(trainingItem,index) in trainingItems"
              :key="index"
            >
              <v-expansion-panel-header disable-icon-rotate>
                <div>
                  <div>{{ getItemDesc(courseItems,trainingItem.courseItemID) }}</div>
                  <div>{{ getItemDesc(courseItemCategories,trainingItem.courseItemCategoryID) }} <span v-if="trainingItem.courseItemMachineID">({{ getItemDesc(courseItemMachines,trainingItem.courseItemMachineID) }})</span></div>
                </div>
                <template v-slot:actions>
                  <v-icon
                    large
                    color="#FF0000"
                    @click="e=>removeTrainingItem(e,trainingItem,index)"
                  >
                    mdi-delete-outline
                  </v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <InputContainer
                  :record="trainingItems[index]"
                  :configs="trainingItems[index].trainingItemConfig"
                  @input="(key,val)=>{handleInput(index,key,val)}"
                >
                </InputContainer>
                <section
                  v-if="trainingItem.showTrainingSet"
                >
                  <TrainingSet
                    v-for="(trainingSet,setIndex) in trainingItem.trainingSets"
                    :key="setIndex+'_'+index"
                    :record-lbs-kgs="trainingSet.lbsKgs"
                    :record-qty="trainingSet.qty"
                    :number="setIndex+1"
                    :unit="trainingItem.unit"
                    @input="(set)=>{handleSetInput(index,setIndex,set)}"
                  ></TrainingSet>
                </section>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </section>
        <section
          v-show="tab == 'aerobic'"
          class="pt-3"
        >
          <v-expansion-panels>
            <v-expansion-panel
              v-for="(trainingAerobicItem,index) in trainingAerobicItems"
              :key="index"
            >
              <v-expansion-panel-header disable-icon-rotate>
                <div>
                  <div>{{ getItemDesc(aerobicItems,trainingAerobicItem.aerobicItemID) }}</div>
                  <div>{{ trainingAerobicItem.duration }} {{ trainingAerobicItem.unit }}</div>
                </div>
                <template v-slot:actions>
                  <v-icon
                    large
                    color="#FF0000"
                    @click="e=>removeTrainingAerobicItem(e,trainingAerobicItem,index)"
                  >
                    mdi-delete-outline
                  </v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <InputContainer
                  :record="trainingAerobicItems[index]"
                  :configs="trainingAerobicItems[index].aerobicItemConfig"
                  @input="(key,val)=>{handleAerobicItemInput(index,key,val)}"
                >
                </InputContainer>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </section>
        <v-btn
          v-show="tab != 'summary'"
          fab
          elevation="1"
          class="create-abs-btn"
          dark
          fixed
          color="rgba(0,136,0,0.7)"
          @click="handleCreate"
        >
          <v-icon
            size="36"
            color="white"
          >
            mdi-plus
          </v-icon>
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
<script setup>
import { ref, onMounted, watch, toRefs, onBeforeUnmount } from 'vue'
import SwipeList from '@/components/SwipeList/SwipeList'
import UniversalInput from '@/components/CRUD/UniversalInput.vue'
import InputContainer from '@/components/CRUD/InputContainer.vue'
import ConfirmDialog from '@/components/Dialog/ConfirmDialog.vue'
import { formatTime, formatDate, loading, handleSelectionResponse } from '@/utils/helper'
import {
  listCourseItem,
  listCourseItemMachine,
  listCourseItemCategory,
  listAerobicItem,
  listTrainingSetUnit,
  updateItem,
  getItem,
} from '@/api/diaryRecord'
import TrainingSet from './DiaryRecord/TrainingSet.vue'
import { fetchCourseComment, fetchWorkoutType } from '@/api/courseComment'

const panel = ref(-1)

const confirmDeleteDialog = ref(false)
const confirmDeleteTrainingAerobicItemDialog = ref(false)

const nodeHeight = ref('0px')
function updateNodeHeight() { nodeHeight.value = `${window.innerHeight - 120}px` }

const props = defineProps({
  value: {
    type: Boolean,
    default: false,
  },
  bookingInfoProp: {
    type: Object,
    default() {
      return {
        id: -1,
        bookingNo: 'BAM2200001',
        userRecord: {
          fullName: 'Paul Chan',
        },
        center: {
          description: 'Mong Kok',
        },
        courseDate: '2023-02-16',
        courseStartTime: '2023-02-16T01:00:00.000Z',
        courseEndTime: '2023-02-16T02:00:00.000Z',
        trainingItems: [{
          id: -1,
          qty: -1,
          lbsKgs: -1,
        }],
        trainingAerobicItems: [],
      }
    },
  },
})
const { value, bookingInfoProp } = toRefs(props)

const diaryDialog = ref(value.value)

const emits = defineEmits(['input', 'closed'])
const tab = ref('summary')
const tabIndex = ref(0)
watch(diaryDialog, val => {
  // console.log('diaryDialog', val)
  emits('input', val)

  tabIndex.value = 0
  tab.value = 'summary'
})

watch(value, val => {
  // console.log('value', val)
  diaryDialog.value = val
})
const trainingItemConfig = [{
  propName: 'courseItemCategoryID',
  label: 'Course Item Category',
  type: {
    name: 'radioGroup',
    hideDetails: true,
    isHorizontal: true,
    groupItems: [],
  },
}, {
  propName: 'courseItemID',
  label: 'Course Item',
  hide: true,
  type: {
    name: 'radioGroup',
    hideDetails: true,
    isHorizontal: true,
    groupItems: [],
  },
}, {
  propName: 'courseItemMachineID',
  label: 'Course Item Machine',
  hide: true,
  type: {
    name: 'radioGroup',
    hideDetails: true,
    isHorizontal: true,
    groupItems: [],
  },
},
{
  hide: true,
  propName: 'remark',
  label: 'Remark',
}]

const defaultTrainingSets = [{
  setName: '1',
  lbsKgs: 0,
  qty: 0,
}, {
  setName: '2',
  lbsKgs: 0,
  qty: 0,
}, {
  setName: '3',
  lbsKgs: 0,
  qty: 0,
}, {
  setName: '4',
  lbsKgs: 0,
  qty: 0,
}, {
  setName: '5',
  lbsKgs: 0,
  qty: 0,
}, {
  setName: '6',
  lbsKgs: 0,
  qty: 0,
}]
const defaultTrainingItem = {
  id: null,
  courseItemCategoryID: null,
  courseItemID: null,
  courseItemMachineID: null,
  unit: 'Times',
  showTrainingSet: false,
  trainingItemConfig: JSON.parse(JSON.stringify(trainingItemConfig)),
  trainingSets: JSON.parse(JSON.stringify(defaultTrainingSets)),
}
const trainingItems = ref([
  // {
  //   ...defaultTrainingItem,
  // },
])

const workingRemoveTrainingItem = ref(null)
const workingRemoveIndex = ref(-1)

function removeTrainingItem(e, removeTrainingItem, index) {
  e.stopPropagation()
  confirmDeleteDialog.value = true
  workingRemoveTrainingItem.value = removeTrainingItem
  workingRemoveIndex.value = index
}

function confirmRemoveTrainingItem() {
  trainingItems.value.splice(workingRemoveIndex.value, 1)
  confirmDeleteDialog.value = false
  workingRemoveTrainingItem.value = null
  workingRemoveIndex.value = -1
}

function handleSetInput(index, setIndex, set) {
  trainingItems.value[index].trainingSets[setIndex] = { ...set }
}

const aerobicItemConfig = [{
  propName: 'aerobicItemID',
  type: {
    name: 'radioGroup',
    hideDetails: true,
    isHorizontal: true,
    groupItems: [],
  },
}, {
  propName: 'duration',
  defaultValue: 0,
  hide: true,
  type: {
    name: 'slider',
  },
}]

const defaultAerobicItem = {
  id: null,
  aerobicItemID: 0,
  duration: 0,
  unit: 'Times',
  aerobicItemConfig: JSON.parse(JSON.stringify(aerobicItemConfig)),
}
const trainingAerobicItems = ref([
  // {
  //   ...defaultAerobicItem,
  // },
])

const workingRemoveTrainingAerobicItem = ref(null)
const workingRemoveTrainingAerobicItemIndex = ref(-1)

function removeTrainingAerobicItem(e, removeTrainingItem, index) {
  e.stopPropagation()
  confirmDeleteTrainingAerobicItemDialog.value = true
  workingRemoveTrainingAerobicItem.value = removeTrainingItem
  workingRemoveTrainingAerobicItemIndex.value = index
}

function confirmRemoveTrainingAerobicItem() {
  trainingAerobicItems.value.splice(workingRemoveTrainingAerobicItemIndex.value, 1)
  confirmDeleteTrainingAerobicItemDialog.value = false
  workingRemoveTrainingAerobicItem.value = null
  workingRemoveTrainingAerobicItemIndex.value = -1
}

// function handleSelectionResponse(res) {
//   const items = []
//   if (res.data.items && res.data.items.length > 0) {
//     res.data.items.forEach(item => {
//       const clone = { ...item }
//       clone.itemValue = item.id
//       clone.itemName = item.description
//       clone.label = item.description
//       items.push(clone)
//     })

//     return items
//   }
// }
const workoutIntensity = ref(200)
function handleCreate() {
  console.log('handleCreate', tab.value)
  if (tab.value === 'exercies') {
    const defaultItem = JSON.parse(JSON.stringify(defaultTrainingItem))
    defaultItem.trainingItemConfig = JSON.parse(JSON.stringify(trainingItemConfig))
    trainingItems.value.push(defaultItem)
    panel.value = trainingItems.value.length - 1
  } else if (tab.value === 'aerobic') {
    const defaultItem = JSON.parse(JSON.stringify(defaultAerobicItem))
    defaultItem.aerobicItemConfig = JSON.parse(JSON.stringify(aerobicItemConfig))
    trainingAerobicItems.value.push(defaultItem)
  }
}

const bodyPart = ref(null)
const workoutTypeSelection = [...fetchWorkoutType()]
const bodyPartConfig = ref([
  {
    propName: 'workoutTypeID',
    label: 'Workout Type',
    defaultValue: 1,
    type: {
      name: 'radioGroup',
      hideDetails: true,
      isHorizontal: true,
      groupItems: [
        ...workoutTypeSelection,
      ],
    },
  },
  {
    propName: 'workoutIntensity',
    defaultValue: 80,

    // label: 'Workout Intensity',
    toplabel: 'Workout Intensity',
    type: {
      name: 'slider',
      min: 40,
      max: 100,
      sliderCallback(val) {
        return `${val}%`
      },
    },
  },
])

const courseCommentSelection = [...fetchCourseComment()]
const dailyEvaluation = ref(null)
const dailyEvaluationConfig = ref([
  {
    propName: 'dailyEvaluation',
    defaultValue: '',
    toplabel: '',
  },
  {
    propName: 'hourSelptLastNight',
    toplabel: 'Sleep(hrs)',
    defaultValue: 5,
    type: {
      name: 'slider',
      min: 3,
      max: 10,
      sliderCallback(val) {
        if (val >= 10) {
          return '10+ hrs'
        }

        return `${val} hrs`
      },
    },
  },
  {
    propName: 'moodID',
    label: 'Mood',
    defaultValue: 1,
    type: {
      name: 'radioGroup',
      hideDetails: true,
      isHorizontal: true,
      groupItems: [...courseCommentSelection],
    },
  },
  {
    propName: 'appetiteID',
    label: 'Appetite',
    defaultValue: 1,
    type: {
      name: 'radioGroup',
      hideDetails: true,
      isHorizontal: true,
      groupItems: [...courseCommentSelection],
    },
  },
  {
    propName: 'energyID',
    label: 'Energy',
    defaultValue: 1,
    type: {
      name: 'radioGroup',
      hideDetails: true,
      isHorizontal: true,
      groupItems: [...courseCommentSelection],
    },
  },
  {
    propName: 'bodyWeight',
    defaultValue: 50,
    toplabel: 'Body Weight',
    type: {
      name: 'slider',
      min: 30,
      max: 100,
      sliderCallback(val) {
        return `${val} KGS`
      },
    },
  },
  {
    propName: 'caloriesExpended',
    toplabel: 'Calories Expended',
    type: {
      name: 'text',
      suffix: 'Cals',
      inputType: 'number',
      min: 0,
    },
  },
])

const courseItemCategories = ref([])
listCourseItemCategory({}).then(res => {
  console.log('listCourseItemCategory', res)
  courseItemCategories.value = handleSelectionResponse(res)

  // courseItemCategoryConfig.value[0].type.groupItems = courseItemCategories.value
  // trainingItems.value[0].trainingItemConfig.find(item => item.propName === 'courseItemCategoryID').type.groupItems = [...courseItemCategories.value]
  trainingItemConfig.find(item => item.propName === 'courseItemCategoryID').type.groupItems = [...courseItemCategories.value]

  // trainingItemConfig.value.filter(item => item.propName === 'courseItemCategoryID')[0].type.groupItems = courseItemCategories.value
})
const courseItems = ref([])
listCourseItem({}).then(res => {
  console.log('listCourseItem', res)
  courseItems.value = handleSelectionResponse(res)
})

const courseItemMachines = ref([])
listCourseItemMachine({}).then(res => {
  console.log('listCourseItemMachine', res)
  courseItemMachines.value = handleSelectionResponse(res)
})

const aerobicItems = ref([])
listAerobicItem({}).then(res => {
  console.log('listAerobicItem', res)
  aerobicItems.value = handleSelectionResponse(res)

  // trainingAerobicItems.value[0].aerobicItemConfig.find(item => item.propName === 'aerobicItemID').type.groupItems = [...aerobicItems.value]
  aerobicItemConfig.find(item => item.propName === 'aerobicItemID').type.groupItems = [...aerobicItems.value]
})
const trainingSetUnits = ref([])
listTrainingSetUnit({}).then(res => {
  console.log('listTrainingSetUnit', res)
  trainingSetUnits.value = handleSelectionResponse(res)
})

function getItemDesc(items, id) {
  const item = items.find(item => item.id === id)
  if (item) {
    return item.description ? item.description : ''
  }

  return ''
}

function handleAerobicItemInput(itemIndex, key, value) {
  console.log('itemIndex, key, value', itemIndex, key, value)
  if (value) {
    const aerobicItem = trainingAerobicItems.value[itemIndex]
    aerobicItem[key] = value
    const config = aerobicItem.aerobicItemConfig
    if (key === 'aerobicItemID') {
      const aerobicItemIDConfig = config.find(item => item.propName === 'aerobicItemID')
      const { trainingSetUnitID } = aerobicItemIDConfig.type.groupItems.find(item => item.id === value)

      const trainingSetUnit = trainingSetUnits.value.find(item => item.id === trainingSetUnitID)
      console.log('trainingSetUnit', trainingSetUnit)
      aerobicItem.unit = trainingSetUnit.description
      const durationConfig = config.find(item => item.propName === 'duration')
      durationConfig.hide = false
      durationConfig.type.sliderCallback = val => `${val} ${aerobicItem.unit}`
    }
  }
}

function handleInput(itemIndex, key, value) {
  if (value) {
    // console.log('itemIndex, key, value', itemIndex, key, value)
    const trainingItem = trainingItems.value[itemIndex]
    trainingItem[key] = value
    const config = trainingItem.trainingItemConfig
    if (key === 'courseItemCategoryID') {
      const courseItemIDConfig = config.find(item => item.propName === 'courseItemID')

      courseItemIDConfig.hide = false
      courseItemIDConfig.type.groupItems = [...courseItems.value.filter(record => record.courseItemCategoryID === value)]

      // reset config
      const courseItemMachineIDConfig = config.find(item => item.propName === 'courseItemMachineID')

      courseItemMachineIDConfig.hide = true

      courseItemMachineIDConfig.type.groupItems = []

      trainingItem.showTrainingSet = false
      trainingItem.courseItemID = null
      trainingItem.courseItemMachineID = null

      // console.log('trainingItem', trainingItem)

      trainingItem.showTrainingSet = false
    } else if (key === 'courseItemID') {
      const courseItemMachineIDConfig = config.find(item => item.propName === 'courseItemMachineID')
      courseItemMachineIDConfig.type.groupItems = courseItemMachines.value
      courseItemMachineIDConfig.hide = false

      const remarkConfig = config.find(item => item.propName === 'remark')
      remarkConfig.hide = false

      const courseItem = courseItems.value.find(item => item.id === value)

      // console.log('courseItem', courseItem)
      const trainingSetUnit = trainingSetUnits.value.find(item => item.id === courseItem.trainingSetUnitID)

      // console.log('trainingSetUnit', trainingSetUnit)
      trainingItem.unit = trainingSetUnit.description
      trainingItem.showTrainingSet = true
    }
  }
}

const currentRecord = ref({
  courseDate: null,
  userRecordID: null,

  workoutTypeID: 1,
  workoutIntensity: null,

  dailyEvaluation: null,
  hourSelptLastNight: null,
  moodID: null,
  appetiteID: null,
  energyID: null,
  bodyWeight: null,
  caloriesExpended: null,
  trainingItems: [],
  trainingAerobicItems: [],
})
function setupDefaultRecord(booking) {
  currentRecord.value.id = 0

  currentRecord.value.userRecordID = booking.userRecordID
  currentRecord.value.courseDate = booking.courseDate
  currentRecord.value.workoutTypeID = 1
  currentRecord.value.workoutIntensity = 80
  currentRecord.value.dailyEvaluation = ''
  currentRecord.value.hourSelptLastNight = 8
  currentRecord.value.moodID = 1
  currentRecord.value.appetiteID = 1
  currentRecord.value.energyID = 1
  currentRecord.value.bodyWeight = 50
  currentRecord.value.caloriesExpended = 2000
  currentRecord.value.trainingItems = []
  currentRecord.value.trainingAerobicItems = []
}

function getRecord() {
  loading(true)

  // get diary record
  return getItem({
    courseDate: bookingInfoProp.value.courseDate,
    userRecordID: bookingInfoProp.value.userRecordID,
  }).then(res => {
    const { record } = res.data
    if (record) {
      currentRecord.value = { ...record }
    } else {
      setupDefaultRecord(bookingInfoProp.value)
    }

    // console.log('currentRecord.value', currentRecord.value)

    if (bodyPart.value) {
      const bodyPartEditedItem = bodyPart.value.editedItem
      bodyPartEditedItem.workoutTypeID = currentRecord.value.workoutTypeID
      bodyPartEditedItem.workoutIntensity = currentRecord.value.workoutIntensity || 0
    }
    if (dailyEvaluation.value) {
      const dailyEvaluationEditedItem = dailyEvaluation.value.editedItem
      dailyEvaluationEditedItem.dailyEvaluation = currentRecord.value.dailyEvaluation || ''
      dailyEvaluationEditedItem.hourSelptLastNight = currentRecord.value.hourSelptLastNight || 5
      dailyEvaluationEditedItem.moodID = currentRecord.value.moodID
      dailyEvaluationEditedItem.appetiteID = currentRecord.value.appetiteID
      dailyEvaluationEditedItem.energyID = currentRecord.value.energyID
      dailyEvaluationEditedItem.bodyWeight = currentRecord.value.bodyWeight
      dailyEvaluationEditedItem.caloriesExpended = currentRecord.value.caloriesExpended
    }
    trainingItems.value = []
    if (currentRecord.value.trainingItems && currentRecord.value.trainingItems.length > 0) {
      for (let index = 0; index < currentRecord.value.trainingItems.length; index += 1) {
        const trainingItem = currentRecord.value.trainingItems[index]
        trainingItem.trainingItemConfig = JSON.parse(JSON.stringify(trainingItemConfig))

        // console.log('trainingItem.trainingItemConfig', trainingItem.trainingItemConfig)

        const config = trainingItem.trainingItemConfig
        const courseItemIDConfig = config.find(item => item.propName === 'courseItemID')

        courseItemIDConfig.hide = false
        courseItemIDConfig.type.groupItems = [...courseItems.value.filter(item => item.courseItemCategoryID === trainingItem.courseItemCategoryID)]

        trainingItem.showTrainingSet = false
        const courseItemMachineIDConfig = config.find(item => item.propName === 'courseItemMachineID')
        courseItemMachineIDConfig.type.groupItems = courseItemMachines.value
        courseItemMachineIDConfig.hide = false

        const remarkConfig = config.find(item => item.propName === 'remark')
        remarkConfig.hide = false

        trainingItem.showTrainingSet = true
        for (let setIndex = 0; setIndex < defaultTrainingSets.length; setIndex += 1) {
          const defaultTrainingSet = defaultTrainingSets[setIndex]
          const exitTrainingSet = trainingItem.trainingSets[setIndex]
          if (!exitTrainingSet) {
            trainingItem.trainingSets[setIndex] = defaultTrainingSet
          }
        }
      }
    }
    trainingItems.value = currentRecord.value.trainingItems
    trainingAerobicItems.value = []
    if (currentRecord.value.trainingAerobicItems && currentRecord.value.trainingAerobicItems.length > 0) {
    // const defaultItem = JSON.parse(JSON.stringify(defaultAerobicItem))

      // defaultItem.aerobicItemConfig = JSON.parse(JSON.stringify(aerobicItemConfig))
      for (let index = 0; index < currentRecord.value.trainingAerobicItems.length; index += 1) {
        const trainingAerobicItem = currentRecord.value.trainingAerobicItems[index]
        trainingAerobicItem.aerobicItemConfig = JSON.parse(JSON.stringify(aerobicItemConfig))
        const config = trainingAerobicItem.aerobicItemConfig

        // const aerobicItemIDConfig = config.find(item => item.propName === 'aerobicItemID')
        // const { trainingSetUnitID } = aerobicItemIDConfig.type.groupItems.find(item => item.id === value)

        // const trainingSetUnit = trainingSetUnits.value.find(item => item.id === trainingSetUnitID)
        // console.log('trainingSetUnit', trainingSetUnit)
        // trainingAerobicItem.unit = trainingSetUnit.description
        const durationConfig = config.find(item => item.propName === 'duration')
        durationConfig.hide = false
        durationConfig.type.sliderCallback = val => `${val} ${trainingAerobicItem.unit}`

      // const existItem = Object.assign({}, defaultItem, trainingAerobicItem);
      // trainingAerobicItems.value.push(existItem)
      }
    }
    trainingAerobicItems.value = currentRecord.value.trainingAerobicItems

    // console.log('currentRecord.value', currentRecord.value)
  }).finally(() => {
    loading(false)
  })
}
watch(bodyPart, newVal => {
  if (newVal) {
    const bodyPartEditedItem = bodyPart.value.editedItem
    bodyPartEditedItem.workoutTypeID = currentRecord.value.workoutTypeID
    bodyPartEditedItem.workoutIntensity = currentRecord.value.workoutIntensity || 0
  }
})
watch(dailyEvaluation, newVal => {
  if (newVal) {
    const dailyEvaluationEditedItem = dailyEvaluation.value.editedItem
    dailyEvaluationEditedItem.dailyEvaluation = currentRecord.value.dailyEvaluation || ''
    dailyEvaluationEditedItem.hourSelptLastNight = currentRecord.value.hourSelptLastNight || 5
    dailyEvaluationEditedItem.moodID = currentRecord.value.moodID
    dailyEvaluationEditedItem.appetiteID = currentRecord.value.appetiteID
    dailyEvaluationEditedItem.energyID = currentRecord.value.energyID
    dailyEvaluationEditedItem.bodyWeight = currentRecord.value.bodyWeight
    dailyEvaluationEditedItem.caloriesExpended = currentRecord.value.caloriesExpended
  }
})
watch(bookingInfoProp, booking => {
  console.log('bookingInfoProp udpate', booking)

  // get diary record
  getRecord()

  // trainingAerobicItems.value = []
  // if (record.trainingAerobicItems && record.trainingAerobicItems.length > 0) {
  //   trainingAerobicItems.value = [...record.trainingAerobicItems]
  // }
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateNodeHeight)
})

onMounted(() => {
  updateNodeHeight()
  window.addEventListener('resize', updateNodeHeight)
  getRecord().then(() => {
    diaryDialog.value = value.value
  })
})

function handleDiary() {
  console.log('bookingInfoProp.value', bookingInfoProp.value)
  loading(true)

  // const record = {
  //   ...bookingInfoProp.value,
  //   ...bodyPart.value.editedItem,
  //   ...dailyEvaluation.value.editedItem,
  //   trainingItems: [...trainingItems.value],
  //   trainingAerobicItems: [...trainingAerobicItems.value],
  // }
  const record = currentRecord.value
  record.workoutTypeID = bodyPart.value.editedItem.workoutTypeID
  record.workoutIntensity = bodyPart.value.editedItem.workoutIntensity

  record.dailyEvaluation = dailyEvaluation.value.editedItem.dailyEvaluation
  record.hourSelptLastNight = dailyEvaluation.value.editedItem.hourSelptLastNight
  record.moodID = dailyEvaluation.value.editedItem.moodID
  record.appetiteID = dailyEvaluation.value.editedItem.appetiteID
  record.energyID = dailyEvaluation.value.editedItem.energyID
  record.bodyWeight = dailyEvaluation.value.editedItem.bodyWeight
  record.caloriesExpended = dailyEvaluation.value.editedItem.caloriesExpended
  record.trainingItems = [...trainingItems.value]
  record.trainingAerobicItems = [...trainingAerobicItems.value]

  console.log('record', record)
  updateItem(record).then(res => {
    // console.log('updateItem', res)
    getRecord()
    diaryDialog.value = false
    emits('closed')
  })
}

</script>
<style scoped>
/* .small-label{
  font-size: 12px;
} */
.v-slide-group__prev{
  display: none !important;
}

.create-abs-btn-mobile{
  bottom: -28px;
  right:40px
}
.create-abs-btn{
  bottom: 45px;
  right:20px
}
.mb-20{
  margin-bottom: 80px;
}
</style>
<style>
.v-slide-group__prev{
  display: none !important;
}
</style>
